import React from "react";

import DashboardView from "../modules/Dashboard";

export default function Dashboard() {
  return <DashboardView />;
}
